export * from './card.module';
export * from './card.component';


// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/layout/card/index.ts